import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Header from "../components/ContainerHeader";
import RequestMe_and_RequestsOther from "../components/RequestMe_and_RequestsOther";
import Sponsor from "../components/project/Sponsor";
import Lists from "../components/project/Lists";
import { Button, FontIcon } from "react-md";

import { getProject } from "../actions/resourceActions";
import { getRequest } from "../actions/requestActions";

import {TouchPageHeader, TouchPageHeader_and_content_spaceBetween} from "../AtollonTheme/ReactElements";

const Project = ({ history, project }) => {
  if (!project) return <div />;

  return (
    <div className="flex-col">

        <TouchPageHeader
            title={project.name}
            buttons={(
                <div>
                    <Button
                        raised
                        className="btn btn-primary touchButton-1"
                        label="Nový požadavek"
                        onClick={() => history.push( "/request-new" )}
                    >
                        {<FontIcon className="color-white">album</FontIcon>}
                    </Button>
                    <Button
                        raised
                        className="btn btn-primary touchButton-3"
                        label="Zadat přijatý požadavek"
                        onClick={() => history.push( "/request-received" )}
                    />
                </div>
            )}
        />
        <TouchPageHeader_and_content_spaceBetween heightPx={50}/>

      <RequestMe_and_RequestsOther history={history} />
      <Lists users={project.relatedResources} history={history} />
      {project.parent && (
        <Sponsor
          name={project.name}
          identifier={project.parent.identifier}
          history={history}
        />
      )}
    </div>
  );
};

export default compose(
  connect(({ resource: { project } }) => ({ project }), {
    getProject,
    getRequest
  }),
  lifecycle({
    async componentWillMount() {
      const { match, getProject, getRequest } = this.props;

      getProject(match.params.id);
      getRequest({
        includeCount: "true",
        limit: 5,
        side: "PENDING",
        status: "INITIAL,ACCEPTED,RESOLVING",
        project: match.params.id
      });
      getRequest({
        includeCount: "true",
        limit: 5,
        side: "NOT_PENDING",
        status: "INITIAL,ACCEPTED,RESOLVING",
        project: match.params.id
      });
    }
  })
)(Project);



// WEBPACK FOOTER //
// ./src/pages/Project.js